/* TuinDepot — aarde-PDP (td-aarde.js) v1.0 · 2026-10-04 (teelaarde, compost, tuinturf, mengcompost en topdressing in bigbag van 1 m³: galerij, aantal-stepper, rekenhulp met toepassingsknoppen, sticky koopbalk) · hoort bij sections/td-aarde-pdp.liquid */
(function (G) {
  'use strict';

  /* ================= pure helpers (ook in node getest) ================= */
  function fmtMoney(c) {
    var v = (Math.round(c) / 100).toFixed(2).replace('.', ',');
    return '€' + v.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function fmtKg(kg) { return String(Math.round(kg)).replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kg'; }
  function nl(x, d) { var f = Math.pow(10, d == null ? 2 : d); return String(Math.round(x * f) / f).replace('.', ','); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* rekenhulp: oppervlak (m²) × laagdikte (cm) → m³ → aantal bigbags van 1 m³ (naar boven afgerond, minstens 1) */
  function calcBags(area, cm, reserve) {
    var m3 = area * cm / 100 * (1 + (reserve || 0) / 100);
    return { m3: m3, bags: Math.max(1, Math.ceil(m3 - 1e-9)) };
  }

  var util = { fmtMoney: fmtMoney, fmtKg: fmtKg, nl: nl, calcBags: calcBags };
  if (typeof document === 'undefined') { if (typeof module !== 'undefined' && module.exports) module.exports = util; return; }
  if (G.TDAarde) { if (G.TDAarde.scan) G.TDAarde.scan(); return; }

  /* ================= DOM-deel ================= */
  var TD = G.TDAarde = { util: util, main: null, subs: [] };
  function notify() { TD.subs.forEach(function (fn) { try { fn(TD.main); } catch (e) {} }); }
  TD.onState = function (fn) { TD.subs.push(fn); if (TD.main) { try { fn(TD.main); } catch (e) {} } };

  /* ---------- hoofdsectie ---------- */
  function initMain(root) {
    if (root.__tda) return;
    var dEl = root.querySelector('[data-td-aa-data]'), data;
    if (!dEl) return;
    try { data = JSON.parse(dEl.textContent); } catch (e) { return; }
    root.__tda = true;
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var P = { id: data.id, p: data.p, w: data.kg > 0 ? data.kg : 0, a: !!data.a };
    var qcfg = parseInt(root.getAttribute('data-qmax'), 10) || 20;
    var maxKg = parseFloat(root.getAttribute('data-maxkg')) || 0;
    var qmax = qcfg;
    if (maxKg && P.w) qmax = Math.min(qcfg, Math.max(1, Math.floor(maxKg / P.w + 1e-9)));
    var qtyEl = q('[data-td-aa-qty]'), numEl = q('[data-td-aa-num]');
    var S = { qty: 1 };

    /* galerij */
    var track = q('[data-td-aa-track]'), dots = qa('[data-td-aa-goto]'), curEl = q('[data-td-aa-cur]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('[data-td-aa-slide]')) : [];
    function goTo(i) {
      if (!track || !slides.length) return;
      i = ((i % slides.length) + slides.length) % slides.length;
      track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
    }
    function idx() { return track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0; }
    if (track && dots.length && 'IntersectionObserver' in G) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.intersectionRatio >= 0.6) {
            var i = parseInt(en.target.getAttribute('data-td-aa-slide'), 10);
            dots.forEach(function (d) { d.classList.toggle('is-on', parseInt(d.getAttribute('data-td-aa-goto'), 10) === i); });
            if (curEl) curEl.textContent = i;
          }
        });
      }, { root: track, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-td-aa-goto'), 10) - 1); }); });
    var prev = q('[data-td-aa-prev]'), next = q('[data-td-aa-next]');
    if (prev) prev.addEventListener('click', function () { goTo(idx() - 1); });
    if (next) next.addEventListener('click', function () { goTo(idx() + 1); });

    /* alles tekenen vanuit de staat */
    function set(sel, txt) { qa(sel).forEach(function (e) { e.textContent = txt; }); }
    function render() {
      S.qty = Math.max(1, Math.min(qmax, parseInt(S.qty, 10) || 1));
      if (numEl) { numEl.value = S.qty; numEl.max = qmax; }
      if (qtyEl) qtyEl.value = S.qty;
      var tot = P.p * S.qty;
      set('[data-td-aa-price]', fmtMoney(tot));
      set('[data-td-aa-total]', fmtMoney(tot));
      set('[data-td-aa-unit]', S.qty === 1
        ? 'per bigbag van 1 m³' + (P.w ? ' (± ' + fmtKg(P.w) + ')' : '')
        : 'voor ' + S.qty + ' bigbags, samen ' + S.qty + ' m³' + (P.w ? ' (± ' + fmtKg(P.w * S.qty) + ')' : '') + ' · ' + S.qty + ' × ' + fmtMoney(P.p));
      set('[data-td-aa-vol]', S.qty + ' m³');
      set('[data-td-aa-kg]', P.w ? '± ' + fmtKg(P.w * S.qty) : '');
      set('[data-td-aa-slabel]', S.qty + ' × 1 m³');
      qa('[data-td-aa-step]').forEach(function (b) {
        var d = parseInt(b.getAttribute('data-td-aa-step'), 10);
        b.disabled = (d < 0 && S.qty <= 1) || (d > 0 && S.qty >= qmax);
      });
      var atc = q('[data-td-aa-atc]'); if (atc) atc.disabled = !P.a;
      notify();
    }
    qa('[data-td-aa-step]').forEach(function (b) {
      b.addEventListener('click', function () { S.qty = (parseInt(numEl.value, 10) || 1) + parseInt(b.getAttribute('data-td-aa-step'), 10); render(); });
    });
    if (numEl) numEl.addEventListener('change', function () { S.qty = parseInt(numEl.value, 10) || 1; render(); });

    /* sticky balk */
    var sticky = q('[data-td-aa-sticky]'), atcBtn = q('[data-td-aa-atc]');
    if (sticky && atcBtn && 'IntersectionObserver' in G) {
      new IntersectionObserver(function (entries) {
        var en = entries[0], passed = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', passed); sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
      }, { threshold: 0 }).observe(atcBtn);
      var sbtn = q('[data-td-aa-sticky-btn]');
      if (sbtn) sbtn.addEventListener('click', function () {
        var f = root.querySelector('form[data-type="add-to-cart-form"]');
        if (!f) return;
        if (typeof f.requestSubmit === 'function') f.requestSubmit(); else atcBtn.click();
      });
    }

    /* toegang voor de rekenhulp */
    TD.main = {
      root: root,
      state: function () { return { qty: S.qty, p: P.p, w: P.w, qmax: qmax }; },
      choose: function (o) { if (o && o.qty) S.qty = o.qty; render(); },
      focusBuy: function () { var a = q('[data-td-aa-atc]'); if (a && a.scrollIntoView) a.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    };
    render();
  }

  /* ---------- rekenhulp ---------- */
  function initCalc(root) {
    if (root.__tda) return;
    root.__tda = true;
    var q = function (s) { return root.querySelector(s); };
    var cm0 = parseFloat(root.getAttribute('data-cm')) || 10;
    var reserve = parseFloat(root.getAttribute('data-reserve')) || 0;
    var m2In = q('[data-td-aa-m2in]'), lIn = q('[data-td-aa-lin]'), bIn = q('[data-td-aa-bin]'), cmIn = q('[data-td-aa-cmin]'), out = q('[data-td-aa-calcout]'), opts = q('[data-td-aa-opts]');
    if (!m2In || !cmIn || !out || !opts) return;
    var uses = Array.prototype.slice.call(root.querySelectorAll('[data-td-aa-use]')), tipEl = q('[data-td-aa-usetip]');
    var lastSig = '', mode = (lIn && bIn) ? 'lb' : 'm2';
    function dn(el) { var n = parseFloat(String(el && el.value || '').replace(',', '.')); return n > 0 ? n : 0; }

    function mark() {
      var cm = dn(cmIn), hit = null;
      uses.forEach(function (u) {
        var on = Math.abs((parseFloat(u.getAttribute('data-cm')) || 0) - cm) < 1e-6;
        u.classList.toggle('is-on', on); u.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on && !hit) hit = u;
      });
      if (tipEl) { var t = hit ? (hit.getAttribute('data-tip') || '') : ''; tipEl.textContent = t; tipEl.hidden = !t; }
    }
    function run() {
      var l = dn(lIn), bw = dn(bIn), a = mode === 'lb' ? l * bw : dn(m2In), cm = dn(cmIn) || cm0;
      if (!(a > 0)) { lastSig = ''; opts.innerHTML = ''; out.textContent = mode === 'lb' ? 'Vul je lengte en breedte in.' : 'Vul je oppervlak in.'; return; }
      var r = calcBags(a, cm, reserve);
      var head = 'Voor ' + (mode === 'lb' ? nl(l, 1) + ' × ' + nl(bw, 1) + ' m (' + nl(a, 1) + ' m²)' : nl(a, 1) + ' m²') + ' op ' + nl(cm, 1) + ' cm heb je ± ' + nl(r.m3) + ' m³ nodig.';
      var m = TD.main;
      if (!m) { lastSig = ''; opts.innerHTML = ''; out.textContent = head; return; }
      var st = m.state();
      /* alleen opnieuw tekenen bij een andere uitkomst: anders vervangt de blur van het m²-veld de knop onder je vinger en gaat de tik op "Kies" verloren */
      var sig = head + '|' + r.bags + '|' + st.p + '|' + st.qmax;
      if (sig === lastSig) return;
      lastSig = sig; opts.innerHTML = '';
      if (r.bags > st.qmax) { out.textContent = head + ' Dat is meer dan we in één levering brengen: neem contact met ons op.'; return; }
      out.textContent = head;
      var d = document.createElement('div');
      d.className = 'tds-opt is-best';
      d.innerHTML = '<span><b>' + r.bags + ' bigbag' + (r.bags > 1 ? 's' : '') + '</b><small>' + r.bags + ' m³' + (st.w ? ' · ± ' + esc(fmtKg(st.w * r.bags)) : '') + ' · ' + esc(fmtMoney(st.p * r.bags)) + '</small></span>';
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'tds-opt-btn'; b.textContent = 'Kies';
      b.addEventListener('click', function () { m.choose({ qty: r.bags }); if (root.tagName === 'DETAILS') root.open = false; m.focusBuy(); });
      d.appendChild(b); opts.appendChild(d);
    }

    [m2In, lIn, bIn].forEach(function (el) { if (el) el.addEventListener('input', run); });
    cmIn.addEventListener('input', function () { mark(); run(); });
    uses.forEach(function (u) {
      u.addEventListener('click', function () { cmIn.value = parseFloat(u.getAttribute('data-cm')) || cm0; mark(); run(); });
    });
    var modeBtns = Array.prototype.slice.call(root.querySelectorAll('[data-td-aa-mode]')), panes = Array.prototype.slice.call(root.querySelectorAll('[data-td-aa-pane]'));
    modeBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.getAttribute('data-td-aa-mode');
        modeBtns.forEach(function (o) { var on = o === b; o.classList.toggle('is-on', on); o.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        panes.forEach(function (pn) { pn.hidden = pn.getAttribute('data-td-aa-pane') !== mode; });
        run();
      });
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-td-aa-cmstep]'), function (b) {
      b.addEventListener('click', function () {
        var dir = parseInt(b.getAttribute('data-td-aa-cmstep'), 10), cur = dn(cmIn) || cm0;
        var s = (cur < 1 || (cur <= 1 && dir < 0)) ? 0.1 : 1;
        cmIn.value = Math.max(0.1, Math.min(50, Math.round((cur + dir * s) * 10) / 10));
        mark(); run();
      });
    });
    TD.onState(function () { run(); });
    mark();
    run();
  }

  TD.scan = function () {
    Array.prototype.forEach.call(document.querySelectorAll('[data-td-aa-main]'), initMain);
    Array.prototype.forEach.call(document.querySelectorAll('[data-td-aa-calc]'), initCalc);
  };
  TD.scan();
  document.addEventListener('shopify:section:load', TD.scan);
})(typeof window !== 'undefined' ? window : this);
